import { IAction, KEEP_THE_SAME } from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  registrationList: any;
}

const initialState: IState = {
  registrationList: {
    status: null,
    data: null,
  },
};

const RegisterReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_REGISTRATION_LIST:
      return {
        ...state,
        registrationList: {
          ...state.registrationList,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.registrationList.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default RegisterReducer;
